import styled from "styled-components";
export const StyledFooter = styled.footer`
  font-weight: 800;
  font-size: 1.2rem;
  color: var(--secondary-color);
  background-color: var(--bg-secondary);
  padding: 2rem;
`;
